<template>
  <section class="content-area__content login" v-bind:class="{ embedded: inFrame }">
    <vue-title :title="$t('identityProvider:login:title')"></vue-title>
    <div id="downtime-message-container" class="downtime-container" role="alert" data-test-element="active-downtime-message" v-if="isActiveDTM">
      <span class="active-downtime-message">
        <i class="material-icons notification-icon" data-test-element="downtime-message-notification">notifications</i>
        <label class="message-label" data-test-element="downtime-message-label">{{ model.activeDowntimeMessage }}</label>
      </span>
    </div>
    <bulletin-component ref="bulletin"></bulletin-component>
    <h1 class="section-title" v-if="!inFrame">{{ $t('identityProvider:login:title') }}</h1>
    <form ref="form" action="authentication" @submit.prevent="validateBeforeSubmit">
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-generic" v-if="model.showError && !errors.any()">
        <i class="material-icons">warning</i>
        <span v-if="model.errorMessage">{{ model.errorMessage }}</span>
        <span v-else>{{ $t(('identityProvider:login:genericError'), null, [this.$t('identityProvider:tenant:supportName'), this.$t('identityProvider:tenant:customerServicePhoneNumber')]) }}</span>
      </div>
      <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" data-test-element="idp-alert-danger-validation" v-show="errors.any()">
        <i class="material-icons">error</i>
        <span v-if="errors.has('.')">{{ errors.first('.') }}</span>
        <span v-else class="alert-message" data-test-element="alert-message">{{ $t('validation:summary') }}</span>
      </div>
      <div class="panel login">
        <div class="login-form-controls">
          <div class="form-group">
            <label>
              <span class="label">{{ $t('shared:fields:username') }}</span>
              <input name="Username" data-test-element="Username" class="control" v-model="model.username" v-focus v-validate="'required'" :data-vv-as="$t('shared:fields:username')" v-bind:class="{ 'input-validation-error': hasErrorOn('Username') }" autocomplete="off" />
            </label>
            <span class="field-validation-error" v-show="hasErrorOn('Username')">{{ errors.first('Username') }}</span>
          </div>
          <div class="form-group">
            <label>
              <span class="label">{{ $t('shared:fields:password') }}</span>
              <div class="password-container">
                <input :type="showPassword ? 'text' : 'password'" name="Password" data-test-element="Password" class="control" v-model="model.password" v-validate="'required'" :data-vv-as="$t('shared:fields:password')" v-bind:class="{ 'input-validation-error': hasErrorOn('Password') }" autocomplete="off" />
                <span class="toggle-password" @click="togglePasswordVisibility">
                  <i class="material-icons">{{ showPassword ? 'visibility' : 'visibility_off' }}</i>
                </span>
              </div>
            </label>
            <span class="field-validation-error" v-show="hasErrorOn('Password')">{{ errors.first('Password') }}</span>
          </div>
          <div class="form-actions">
            <button type="submit" class="button" id="logonButton" :disabled="disabled">{{ $t('identityProvider:login:submit') }}</button>
          </div>
        </div>
        <div class="other-actions login">
          <div class="action" v-if="model.enrollUrlEnabled">
            <div class="prompt">{{ $t('identityProvider:login:enrollPrompt') }}</div>
            <a class="link" v-if="model.enrollUrl && !isActiveDTM" data-test-element="enroll-user" :href="model.enrollUrl" @click="clickedLink">{{ $t('identityProvider:login:enroll') }}</a>
            <span class="link disable-links" data-test-element="enroll-user" v-if="isActiveDTM">{{ $t('identityProvider:login:enroll') }}</span>
          </div>
          <div class="action" v-if="model.forgottenPasswordEnabled">
            <div class="prompt">{{ forgottenPasswordPrompt }}</div>
            <a class="link" v-if="model.forgottenPasswordUrl && !isActiveDTM" data-test-element="reset-pass" @click="clickedLink" :href="model.forgottenPasswordUrl">{{ forgottenPasswordLink }}</a>
            <span class="link disable-links" data-test-element="reset-pass" v-if="isActiveDTM">{{ forgottenPasswordLink }}</span>
          </div>
          <br />
          <div class="action" v-if="model.showLanguagePreference">
            <a data-test-element="idp-switchLanguage" @click.prevent="switchLanguage" href="authentication/SwitchLanguage" class="switchLanguage link">{{ $t('shared:action:switchLanguage') }}</a>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<style>
</style>

<script>
  import Vue from 'vue';
  import validation from 'utils/validation-mixin';
  import redirectHandler from 'utils/redirect';
  import bulletinMessage from './bulletin-message';

  Vue.component('bulletin-component', bulletinMessage);

  // variable to enable/disable enrollment & reset password links.
  var activeDTM = false;
  function getIOBlackBoxValue() {

    return document.getElementById("ioBlackBox").value;
  }

  export default {
    mixins: [
      validation
    ],

    data: () => ({
      model: {
        username: null,
        password: null,
        returnUrl: null,
        IOBlackBox: null,
        // TODO: Move 'enrollUrl' out of the view model and retrieve from configuration.
        enrollUrl: null,
        activeDowntimeMessage: null,
        alert: null
      },
      disabled: false,
      antiforgery: null,
      forgottenPasswordPrompt: null,
      forgottenPasswordLink: null,
      isActiveDTM: false,
      showPassword: false
    }),

    computed: {
      inFrame() {
        let inFrame;
        try {
          inFrame = window.self !== window.top;
        } catch (e) {
          inFrame = true;
        };

        return inFrame && this.$displayMode === "popup";
      }
    },

    methods: {
      /*
      async post () {
      let form = this.$refs.form;
      try {
      // let response = await this.$http.post(form.action, this.model, {
      //  headers: {
      //   'X-XSRF-TOKEN': this.antiforgery
      //  }
      // });
      let response = await this.$http.post(form.action, this.model);
      if (response.status === 200 && response.data && response.data.redirectUrl) {
      location.href = response.data.redirectUrl;
      }
      } catch (error) {
      if (this.validateResponse(form, error.response)) {
      this.model.password = null;
      return;
      }
      throw error;
      }
      }
      */
      togglePasswordVisibility() {
        this.showPassword = !this.showPassword;
      },

      validateBeforeSubmit() {
        // collapse bulletin message
        this.$refs.bulletin.collapseMessage();

        // Disabling the custom error message div on submit request.
        this.model.showError = false;

        // TODO: Make this an app-level common helper.
        this.$validator.reset()
          .then(_ => {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.post();
              }
            });
          });
      },

      clickedLink(event) {
        if (this.inFrame) {
          window.top.location = event.target.href;
        }
      },

      //Use this to switch language by toggling from login page
      switchLanguage(event) {
        this.$http.post(event.target.href).then(response => {
          window.location.reload(true);
        });
      },

      // Use this if debugging transpiled async/await code is difficult.
      post() {
        let form = this.$refs.form;
        this.model.IOBlackBox = getIOBlackBoxValue();
        this.disabled = true;        
        if (!this.hasAntiforgeryToken()) {
          let antiforgeryError = { "": [this.$t('identityProvider:login:genericErrorReload', null, [this.$t('identityProvider:tenant:supportName'), this.$t('identityProvider:tenant:customerServicePhoneNumber')])] };
          this.showErrorSummary(form, antiforgeryError);
          this.model.password = null;
          return;
        }
        this.$http.post(form.action, this.model)
          .then(response => {
            if (response.status === 200 && response.data && response.data.redirectUrl) {
              // If we are framed (aka tether login) we should break out here
              if (this.inFrame) {
                // a redirect to another route in the vuejs clientapp
                if (this.$router.match(response.data.redirectUrl).matched.length !== 0) {
                  window.top.location = this.$router.resolve(response.data.redirectUrl).href;
                  // a redirect back to the idsrv callback endpoint
                } else {
                  window.top.location = response.data.redirectUrl;
                }
              } else {
                redirectHandler.checkAndRedirect(response, this.$router);
              }
            // Remove bulletin message from DOM
            $('.bulletin-Container').remove();
            }
          })
          .catch(error => {
            if (this.validateResponse(form, error.response)) {
              this.model.password = null;
              return;
            }
            throw error;
          })
          .finally(() => {
            this.disabled = false;
          });
      }
    },

    async mounted() {
      let returnUrl = this.$route.query['returnUrl'];
      let showError = this.$route.query['showError'];
      let errorCode = this.$route.query['errorCode'];
      let form = this.$refs.form;
      this.forgottenPasswordPrompt = this.$t('identityProvider:login:forgotPasswordPrompt') + ' ' + this.$t('shared:fields:password').toLowerCase() + '?';
      this.forgottenPasswordLink = this.$t('identityProvider:login:forgotPasswordLink') + ' ' + this.$t('shared:fields:password').toLowerCase();
      this.model.returnUrl = returnUrl;
      try {
        // Importing/requiring 'jquery-validation-unobtrusive'
        // automatically performs the parsing when the document is ready.
        // $.validator.unobtrusive.parse(form);
        let response = await this.$http.get(form.action, {
          params: {
            returnUrl: returnUrl,
            showError: showError,
            errorCode: errorCode
          }
        });

        this.model = response.data;
        if (response.data.activeDowntimeMessage !== null && response.data.activeDowntimeMessage !== '') {
          this.isActiveDTM = true;
          activeDTM = true;
          $('#logonButton').attr("disabled", "disabled");
        }
        // Use a response header if the JavaScript-readable cookie is disallowed.
        // this.antiforgery = response.headers['xsrf-token'];
      } catch (error) {
        if (this.validateResponse(form, error.response)) {
          this.model.password = null;
          return;
        }
        throw error;
      }
    }
  };
</script>